<!-- TODO: 
Give projects top gap on mobile
Make project containers not show when video modal is open
Make video modal better on mobile.
-->
<template> 
  <div class="container mx-auto py-20 fade-in">
    <!-- Modal -->
    <transition name="fade">
      <div v-if="showModal" class="fixed inset-0 flex items-start justify-center bg-black bg-opacity-95">
        <div class="modal-content bg-gray-200 p-6 rounded-lg shadow-lg text-center mt-8">
          <h2 class="text-2xl font-bold mb-4">Welcome to My Projects Page</h2>
          <p class="text-gray-700 mb-4">Unfortunately, some projects may not have links to the deployed application. 
            I am actively working on getting these applications deployed, so please keep an eye out. 
            if you would like a demonstration of the applications that aren't deployed, please contact me at my email or phone number.</p>
          <br />
          <button @click="hideModal" class="delayed-bounce bg-gray-500 text-white px-4 py-2 rounded hover:bg-green-600 hover:animate-bounce">OK</button>
        </div>
      </div>
    </transition>
    <!-- Video Modal -->
    <transition name="fade">
      <div v-if="showVideoModal" class="fade-in fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
        <div class="video-modal bg-gray-200 p-6 rounded-lg shadow-lg text-center">
          <iframe :src="currentVideoUrl" width="560" height="315" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          <br />
          <button @click="hideVideoModal" class="custom-button mt-4 bg-red-500 text-white px-4 py-1 rounded hover:bg-red-600 justify-center">Close</button>
        </div>
      </div>
    </transition>
    <!--Projects-->
    <div class="projects flex justify-center">
      <div class="grid sm:grid-cols-1 lg:grid-cols-3 lg:gap-4 sm:gap-4">
        <!-- Project 1 -->
        <div class="bg-white p-6 rounded-lg shadow-lg lg:col-start-1 lg:row-start-1 transition-transform duration-300 hover:scale-105">
          <h2 class="text-2xl font-bold mb-2">4096</h2>
          <p class="text-gray-700 mb-4">My first group project for the Full-Stack Developer Boot Camp. This is a web application based on the game 2048, but with more tiles.</p>
          <a href="https://github.com/jelliots2/4096" class="text-blue-500 hover:underline" target="_blank" rel="noopener noreferrer">Github Repository</a>
          <br />
          <a href="https://joeyvedder.github.io/4096/" class="text-blue-500 hover:underline" target="_blank" rel="noopener noreferrer">Deployed Link</a>
          <br />
          <a @click.prevent="showVideo('https://www.youtube.com/embed/PmR02dfPjcA')" href="#" class="text-blue-500 hover:underline">Video Demonstration</a>
        </div>
        <!-- Project 2 -->
        <div class="bg-white p-6 rounded-lg shadow-lg lg:col-start-2 lg:row-start-2 sm:col-start-1 sm:row-start-2 self-center transition-transform duration-300 hover:scale-105">
          <h2 class="text-2xl font-bold mb-2">Pix2Print</h2>
          <p class="text-gray-700 mb-4">This was my final group project for the Full-Stack Developer Boot Camp. This is a web application that allows users to convert
            images to STL files to be utilized by 3D printing software.</p>
          <a href="https://github.com/IanStocker02/pix2print" class="text-blue-500 hover:underline">Github Repository</a>
          <br />
          <a @click.prevent="showVideo('https://www.youtube.com/embed/2SYdCSDTnKc')" href="#" class="text-blue-500 hover:underline">Video Demonstration</a>
        </div>
        <!-- Project 3 -->
        <div class="bg-white p-6 rounded-lg shadow-lg lg:col-start-3 lg:row-start-3 sm:col-start-1 sm:row-start-3 self-center transition-transform duration-300 hover:scale-105">
          <h2 class="text-2xl font-bold mb-2">Social Media API</h2>
          <p class="text-gray-700 mb-4">A simple Social Media API. This is an example of my ability to utilize Mongoose and Express JS, as well as testing using applications like Postman.</p>
          <a href="https://github.com/jelliots2/Social-API" class="text-blue-500 hover:underline">Github Repository</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectsPage',
  data() {
    return {
      showModal: true, 
      showVideoModal: false,
      currentVideoUrl: ''
    };
  },
  methods: {
    hideModal() {
      this.showModal = false; 
    },
    showVideo(videoUrl) {
      this.currentVideoUrl = videoUrl; // Set the current video URL
      this.showVideoModal = true; // Show the video modal
    },
    hideVideoModal() {
      this.showVideoModal = false; 
    }
  }
};
</script>

<style scoped>
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

h1 {
  padding-top: 20px;
  margin: 15px;
}

h2 {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 1rem;
}

.projects {
  top: 100px;
}

.modal {
  background-color: rgba(0, 0, 0, 0.5); 
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-start; 
  justify-content: center;
  transition: opacity 0.5s ease-in-out;
}

.modal-content {
  background-color: #f5f5f5; 
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  margin-top: 10rem; 
  width: 80%; 
  max-width: 500px; 
  height: auto; 
  max-height: 80vh; 
  overflow-y: auto; 
}

.video-modal {
  background-color: #2e2e2e; 
  padding: 10px;
  border-radius: 8px;
  text-align: center;
  max-width: 800px; 
  height: auto; 
  max-height: 80vh; 
  transition: opacity 0.5s ease-in-out;
}

.custom-button {
  padding-top: 0.25rem; 
  padding-bottom: 0.25rem; 
}

.fade-in {
  animation: fadeIn 1s ease-in;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.delayed-bounce {
  animation: bounce 1s infinite;
  animation-delay: 5s;
}

@media (max-width: 400px) {
  .video-modal {
    padding: 0px;
  }
}

</style>